import { useState } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import type { SessionUser } from '~/stores/useMember';
import { colors, fontFamily, radii } from '~/ui/tokens';

export function UserAvatar({ user, size = 38 }: { user: SessionUser; size?: number }) {
  // First letters of the first and last name ("Daman Datta" -> "DD"); a single word or an email uses its first two letters.
  const words = user.name.trim().split(/\s+/).filter(Boolean);
  const initials = (words.length > 1 ? words[0][0] + words[words.length - 1][0] : words[0]?.slice(0, 2) || user.email.slice(0, 2)).toUpperCase();
  // A profile photo that fails to load (blocked, expired URL) falls back to initials
  // instead of leaving an empty gap next to the name.
  const [failed, setFailed] = useState(false);
  return user.picture && !failed
    ? <Image source={{ uri: user.picture }} style={{ width: size, height: size, borderRadius: size / 2 }} accessibilityLabel={`${user.name} profile photo`} onError={() => setFailed(true)} />
    : <View style={[styles.fallback, { width: size, height: size, borderRadius: size / 2 }]} accessibilityLabel={`${user.name} profile initials`}>
        <Text style={[styles.initials, { fontSize: Math.max(12, size * 0.36) }]}>{initials}</Text>
      </View>;
}

const styles = StyleSheet.create({
  fallback: { backgroundColor: colors.skyTint, borderWidth: 1, borderColor: colors.line, alignItems: 'center', justifyContent: 'center' },
  initials: { fontFamily: fontFamily.semibold, color: colors.brand },
});
